export const DOCUMENT_STATUSES = {
  UPLOADING: 'uploading',
  DONE: 'done',
  ERROR: 'error',
};
